module.exports = __webpack_public_path__ + "static/media/enery_low_battery.a31eb1e0.svg";